import { useNavigate } from 'react-router';

import { routerHistory } from '#/reduxState/router/routerReducer';

// let globalNavigate: NavigateFunction | null = null;
// export const setGlobalNavigate = (navigate: NavigateFunction) => {
//   globalNavigate = navigate;
// };
// export function GlobalRedirectHandler() {
//   const navigate = useNavigate();
//   useEffect(() => {
//     setGlobalNavigate(navigate);
//   }, [navigate]);
//   return null;
// }

/**
 * Redirect from any API call. Independently from component state.
 */
export const redirectTo = (to: string) => {
  routerHistory.push(to);
  // if (globalNavigate) {
  //   globalNavigate(to);
  // } else {
  //   routerHistory.push(to);
  // }
};

export const openExternalUrl = (
  to: string,
  target = '_blank',
  features = 'noopener'
): void => {
  window.open(to, target, features);
};

export const getCurrentDomainUrl = (path = ''): string => {
  const protocol = window?.location?.protocol
    ? window.location.protocol
    : 'https:';

  const host = window?.location?.host || '/';
  return `${protocol}//${host}/${
    path.startsWith('/') ? path.substring(1) : path
  }`;
};

export const isRunningOnInsecureHttp = (url?: string): boolean =>
  (url || window.location.protocol) === 'http:';

/**
 * Make sure we dont allow user to pass URL address of another site to return links.
 * Returns dashboard "/" address when link is incorrect.
 */
export const sanitizeInternalUrl = (path: string): string => {
  const pathTrimmed = path.trim();
  if (pathTrimmed.startsWith('#')) {
    return pathTrimmed;
  }
  if (pathTrimmed.startsWith('http') || pathTrimmed.startsWith('//')) {
    console.warn(`Link: ${path?.substring(0, 50)}`);
    console.warn('Return link looks incorrect (Might be unsafe)');
    return '/';
  }
  if (!pathTrimmed.startsWith('/')) {
    console.warn(`Link: ${path?.substring(0, 50)}`);
    console.warn('Return link is not valid');
    return '/';
  }
  if (pathTrimmed.length > 100) {
    // Prevent passing any weirdness which might be harmfull
    console.warn(`Link: ${path?.substring(0, 50)}`);
    console.warn('Return address exceeds maximal allowed length');
    return '/';
  }
  return pathTrimmed;
};

/**
 * Keywords to help search: navigateBack, redirectBack, redirectPrevious
 */
export function useNavigateToPrevious(fallbackPath: string) {
  const navigate = useNavigate();
  if (window.history.length > 1) {
    return () => navigate(-1);
  }
  // If there is no navigation history,
  // we have to jump to fallback path
  return () => redirectTo(fallbackPath);
}

// export function redirectToQueryString(prop: string, value: string) {
//   const url = new URL(window.location.href);
//   url.searchParams.set(prop, value);
//   window.location.replace(url.toString());
// }

// export function updateRouterQueryString(prop: string, value: string) {
//   const url = new URL(window.location.href);
//   url.searchParams.set(prop, value);
//   return url.pathname + url.search;
// }
